module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-chevy.167e7697.png";